import { h, defineComponent, inject } from 'vue';
import { ImageAsset } from '@/ui/components/asset/ImageAsset';
import { t } from '@/ui/i18n/i18n';
import FileItem from '@/ui/components/inspectionReport/items/FileItem.vue';
import { isLowQualityImagesFromReportPageKey } from '@/ui/injectionKeys';
import { isPdf } from '@/ui/helpers/systemHelper';
import { isAiImageDescriptionFeatureEnabled } from '@/ui/auth/auth';
// use for urls debug
// import { imageUrl } from '@/services/assets-api/assetsClient';

interface AttachmentInterface {
  attachments: Array<Record<string, string>>;
  files: Array<Record<string, string>>;
  maxPerPage: number;
}

export default defineComponent<AttachmentInterface>({
  name: 'Attachment',
  props: {
    attachments: {
      type: Array,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    },
    maxPerPage: {
      type: Number,
      default: 4,
    },
  },
  setup(props) {
    const isLowQualityImages = inject(isLowQualityImagesFromReportPageKey, false);

    const chunk = (array: Array<Record<string, string>>, size: number) =>
      array.reduce((accumulator: Array<Array<Record<string, string>>>, _, index) => {
        if (index % size === 0) {
          accumulator.push(array.slice(index, index + size));
        }
        return accumulator;
      }, []);

    return function render() {
      return h('div', { class: 'inspection-report__attachments-page' }, [
        h('div', { class: 'inspection-report__attachments-page-title' }, [t('inspection-report.attachments')]),
        h('div', { class: 'inspection-report__attachments-page-files' },
          props.files.map((file: Record<string, string>) => h('div', {
            class: 'inspection-report__attachments-page-file',
          }, [
            h(FileItem, { props: { file } }),
          ]))),
        chunk(props.attachments, props.maxPerPage).map(currentChunk => h('div', {
          class: 'inspection-report__attachments-page-section',
        }, [
          currentChunk.map(attachment => {
            return h('div', [
              h('div', { class: 'inspection-report__attachments-page-section-number' }, [
                h('span', [`${attachment.index}.`]),
              ]),
              h('div', {
                class: 'inspection-report__attachments-page-section-image',
              }, [
                // use for urls debug
                // h('div', { class: 'flex break-all' }, imageUrl(attachment.image_id)),
                h(ImageAsset, {
                  class: 'inspection-report__image-drawing',
                  props: {
                    photo: attachment,
                    isLowQualityImages: isPdf && isLowQualityImages,
                  },
                }),
              ]),
              isAiImageDescriptionFeatureEnabled.value
              && attachment.image_description
                ? h('div', { class: 'mt-1' }, [attachment.image_description])
                : null,
            ]);
          }),
        ])),
      ]);
    };
  },
});
